export default {
    APP_CONTAINER_CLASSNAME: 'App',
};
